const typeBarImg = {
    normal: require('../../Images/type-bar/normal.svg').default,
    fighting: require('../../Images/type-bar/fighting.svg').default,
    flying: require('../../Images/type-bar/flying.svg').default,
    poison: require('../../Images/type-bar/poison.svg').default,
    ground: require('../../Images/type-bar/ground.svg').default,
    rock: require('../../Images/type-bar/rock.svg').default,
    bug: require('../../Images/type-bar/bug.svg').default,
    ghost: require('../../Images/type-bar/ghost.svg').default,
    steel: require('../../Images/type-bar/steel.svg').default,
    fire: require('../../Images/type-bar/fire.svg').default,
    water: require('../../Images/type-bar/water.svg').default,
    grass: require('../../Images/type-bar/grass.svg').default,
    electric: require('../../Images/type-bar/electric.svg').default,
    psychic: require('../../Images/type-bar/psychic.svg').default,
    ice: require('../../Images/type-bar/ice.svg').default,
    dragon: require('../../Images/type-bar/dragon.svg').default,
    dark: require('../../Images/type-bar/dark.svg').default,
    fairy:require('../../Images/type-bar/fairy.svg').default,
    ball:require('../../Images/pokemon-shape/ball.png').default
}   
export default typeBarImg